var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('base-image',{staticClass:"media-image-view",attrs:{"src":_vm.src}}):_c('base-icon',{attrs:{"font-size":24}},[_vm._v(_vm._s(_vm.icon))])}
var staticRenderFns = []

export { render, staticRenderFns }